import React from 'react'
import { BiFolder } from 'react-icons/bi'

import { Folder } from '../../api/services/dietbase/types.ts'

const FolderItem = ({
  folder,
  selectedFolder,
  index
}: {
  folder: Folder
  selectedFolder: number | null
  index: number
}) => {
  return (
    <div className={'flex flex-col items-center text-[14px] -mt-2 mb-4'}>
      <span>{folder.folder_category}</span>
      <div className={'flex relative items-center gap-1'}>
        <div className={'flex items-center justify-center w-full h-full '}>
          <BiFolder
            size={50}
            color={selectedFolder === index ? '#16a34a' : '#bab9b9'}
          />
        </div>
        <div
          className={
            'absolute left-0 top-0.5 flex items-center justify-center w-full h-full'
          }
        >
          <span className={'flex text-center font-bold text-[16px]'}>
            {folder.diets_count}
          </span>
        </div>
      </div>
      <p>
        {'Liczba posiłków: '}
        <span className={'font-bold text-[16px]'}>
          {folder.number_of_meals}
        </span>
      </p>
      <p>
        {'Liczba kalorii: '}
        <span className={'font-bold text-[16px]'}>{folder.kcal}</span>
      </p>
    </div>
  )
}

export default FolderItem
